import { render, staticRenderFns } from "./wlTitle.vue?vue&type=template&id=56f28ad5&scoped=true&"
import script from "./wlTitle.vue?vue&type=script&lang=js&"
export * from "./wlTitle.vue?vue&type=script&lang=js&"
import style0 from "./wlTitle.vue?vue&type=style&index=0&id=56f28ad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f28ad5",
  null
  
)

export default component.exports